import React from 'react'
import { OwnerWalletList } from "./list/page";

export const OwnerWalletsPage = (): JSX.Element => {
  return <OwnerWalletList></OwnerWalletList>
}
